import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { ObjContext } from "./context";

export abstract class SpawnerBuilding extends UnitType {
    abstract readonly spawns: string;
    abstract readonly maxSpawns: number;
    make() { return new GameObj("neutral", this.id); }
    aiAlwaysSteps(): boolean { return true; }
    step(ctx: ObjContext) {
        if (!ctx.obj || !ctx.obj.isReady(this.maxCooldown())) return;
        ctx.obj.setNotReady();

        if (ctx.game.isInTutorial() && this.spawns != "peasant") return
        ctx.game.tryAIPlaceNewObjInRange(15, 1, this.maxSpawns, this.spawns, ctx);
    }
}
